export default defineNuxtRouteMiddleware((to) => {
  const { isFeatureEnabled } = useExperiment()
  const { status } = useAuth()
  const { userEmail } = useUser()
  const rtsessionIdCookie = useRtsessionIdCookie()

  const isLoggedIn = computed(() => status?.value === 'authenticated')

  // Send user identifiers to Clarity
  if (isMetaClient && isLoggedIn.value && isFeatureEnabled('rvz20755clarityFeatureFlag')) {
    SendIdentifiersToClarity({
      customId: userEmail?.value ?? '',
      customPageId: to.name?.toString(),
      customSessionId: rtsessionIdCookie.value ?? '',
    })
  }
})
